import { render, staticRenderFns } from "./AntimatterGalaxyModal.vue?vue&type=template&id=c3b2c3b6&"
import script from "./AntimatterGalaxyModal.vue?vue&type=script&lang=js&"
export * from "./AntimatterGalaxyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports